import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgAngleLeft = function SvgAngleLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.53 3.46967C15.8229 3.76256 15.8229 4.23744 15.53 4.53033L8.94426 11.1161C8.94425 11.1161 8.94425 11.1161 8.94424 11.1161C8.45606 11.6044 8.45612 12.3958 8.94423 12.8839L8.94424 12.8839L15.53 19.4697C15.8229 19.7626 15.8229 20.2374 15.53 20.5303C15.2371 20.8232 14.7623 20.8232 14.4694 20.5303L7.8836 13.9445C7.88359 13.9445 7.88359 13.9445 7.88358 13.9445C6.80961 12.8706 6.80967 11.1295 7.88357 10.0555L7.88358 10.0555L14.4694 3.46967C14.7623 3.17678 15.2371 3.17678 15.53 3.46967Z"
  })));
};

export { SvgAngleLeft as ReactComponent };
//# sourceMappingURL=angle-left.svg.js.map
